import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { TenantService } from '../services/tenant.service';

@Component({
  selector: 'app-give-away-page2',
  templateUrl: './give-away-page2.component.html'
})
export class GiveAwayPage2Component implements OnInit {
  tenantId: any;
  affiliateId: any;
  loadeddata: any;
  tenant: TenantService;
   message: string | null = null;
iconsWithLabels: { icon: string; label: string }[] = [];
  status: string | null = null;;
  constructor(
    private route: ActivatedRoute,
    private settingsService: PageviewsettingsService,
    private tenantService: TenantService,
    private router: Router

  ) {
    const nav = this.router.getCurrentNavigation();
    this.status = nav?.extras?.state?.['status'] || null;
   this.message = nav?.extras?.state?.['message'] || null;
   console.log(this.message)
   
    this.tenant = tenantService;
  }

  ngOnInit() {
    let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

    this.settingsService.getCollegetenantcode(collegeName).subscribe((data: { result: { id: string; affiliateId: any; }; }) => {
      this.tenantId = parseInt(data.result.id)
      this.affiliateId = data.result.affiliateId
      this.loadPageSettings()
    });
       this.iconsWithLabels = this.tenant.getTenantIconItems();
  }

  loadPageSettings() {
    this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
      this.loadeddata = data.result;
       const guid = this.loadeddata.ActiveGiveawayEvent
//   if (!this.status) {
//   this.router.navigate([this.tenant.getName()]);
// }
    });
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      console.log('Form submitted with values:', form.value);
      alert('Thank you for completing the survey!');
      form.reset();
    }
  }
}